import React from 'react'
import assets from 'xui/assets'
import CommonLogo, { ICommonLogoOptionalProps } from './CommonLogo'

// const LOGO = require('../img/packge_tag/silver.png')
const LOGO = assets.images.packgeTag.silver

const SilverPackageTag = (props: ICommonLogoOptionalProps) => <CommonLogo source={LOGO} {...props} />

export default SilverPackageTag
